import styled from 'styled-components';

export const personalInfoStyles = {
  Container: styled.div`
    padding: 30px;
  `,
  Contacts: styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 32px;
  `,
  Block: styled.div`
    margin-top: 40px;

    span {
      display: block;
      font-family: 'Open Sans';
      font-style: normal;
      font-size: 16px;
      line-height: 140%;
      color: #919ca7;
      margin-bottom: 16px;
    }
  `,
  Text: styled.div`
    font-family: 'Open Sans';
    font-style: normal;
    font-size: 16px;
    margin-top: 12px;
    line-height: 140%;
    color: #333333;
  `,
  Empty: styled.div`
    color: #919ca7;
    text-align: center;
    pointer-events: none;
  `,
  FileList: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  Link: styled.a`
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
  `,

  Title: styled.div`
    font-size: 16px;
    line-height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #49a3a6;
  `,
};
